// extracted by mini-css-extract-plugin
export var currentPaginationItem = "pagination-module--currentPaginationItem--450c1 pagination-module--paginationItem--dfe22";
export var pagination = "pagination-module--pagination--b5adf";
export var paginationItem = "pagination-module--paginationItem--dfe22";